import React, { FC } from 'react';

import { Typography } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useTranslation } from 'react-i18next';

import ChevronLeftIcon from '../../../../assets/icons/ChevronLeftIcon';
import { IconButton } from '../../../../components/UI/IconButton';
import { colorsPalette } from '../../../../theme';
import useStyles from './styles';

export interface TableViewHeaderProps {
  title?: string | null;
  description?: string | null;
  goBack: () => void;
  handleExportData?: () => void;
}

const TableViewHeader: FC<TableViewHeaderProps> = ({
  title,
  description,
  goBack,
  handleExportData,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper}>
      {title && (
        <div className={classes.titleBlock}>
          <button data-testid="goBackToAnalytics" className={classes.backBtn} onClick={goBack}>
            <ChevronLeftIcon className={classes.backIcon} color={colorsPalette.blue} />
          </button>
          <Typography data-testid="tableHeaderTitle" variant="h3" className={classes.title}>
            {title}
          </Typography>
        </div>
      )}
      {description && (
        <Typography data-testid="tableHeaderDesc" className={classes.description}>
          {description}
        </Typography>
      )}
      {handleExportData && (
        <div className={classes.exportBlock}>
          <IconButton
            label={t('button.downloadCsv')}
            icon={<CloudDownloadIcon fontSize="small" />}
            onClick={handleExportData}
          />
        </div>
      )}
    </div>
  );
};

export default TableViewHeader;
